import { render, staticRenderFns } from "./ShingalOffice.vue?vue&type=template&id=f3da8348&scoped=true&"
import script from "./ShingalOffice.vue?vue&type=script&lang=js&"
export * from "./ShingalOffice.vue?vue&type=script&lang=js&"
import style0 from "./ShingalOffice.vue?vue&type=style&index=0&id=f3da8348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3da8348",
  null
  
)

export default component.exports